
import {defineComponent, PropType} from 'vue'
import InputColor from "@/components/UI/InputColor.vue";
import InputNumber from "@/components/UI/InputNumber.vue";
import {ColorRestDtoModel} from "@/models/api/ColorRestDtoModel";
import {ComponentMixin} from "@/components/base/ComponentMixin";
import {convertHexToRgb, convertRgbToHex} from "@/helpers/functions/color";

export default defineComponent({
  name: "ColorPicker",
  mixins: [ComponentMixin],
  emits: ["update:modelValue"],
  components: {InputColor, InputNumber},
  props: {
    modelValue: {
      type: Object as PropType<ColorRestDtoModel>,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    label_col_size: {
      type: Number,
      default: 2,
      required: false
    },
    label_bold: {
      type: Boolean,
      default: true,
      required: false
    },
    name: {
      type: String,
      required: true
    },
    read_only: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      localDto: ColorRestDtoModel.cloneFrom(this.modelValue),
      hex: ''
    }
  },
  watch: {
    modelValue: {
      immediate: true,
      handler(newValue: ColorRestDtoModel) {
        this.localDto = ColorRestDtoModel.cloneFrom(newValue);
        this.hex = convertRgbToHex(this.localDto.rgb);
      },
    },
  },
  methods: {
    onHexChanged() {
      this.localDto.rgb = convertHexToRgb(this.hex);
      this.emitModelChanged();
    },
    emitModelChanged(): void {
      this.$emit('update:modelValue', this.localDto);
    }
  }
});
